export const ADD_MOVIE = "ADD_MOVIE";
export const GET_MOVIES = "GET_MOVIES";
export const DELETE_MOVIE = "DELETE_MOVIE";
export const MOVIES_LOADING = "MOVIES_LOADING";
export const FETCH_MOVIE = "FETCH_MOVIE";
export const FETCH_CREDITS = "FETCH_CREDITS";
export const FETCH_TRAILER = "FETCH_TRAILER";
export const LOADING = "LOADING";
//user reducer types
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SEARCH_MOVIES = "SEARCH_MOVIES";
export const SEARCH_MOVIES_LOADING = "SEARCH_MOVIES_LOADING";
export const GENRES_MAP = "GENRES_MAP";
export const COMMENT_SUCCESS = "COMMENT_SUCCESS";
export const COMMENT_FAIL = "COMMENT_FAIL";
export const ADD_WATCHLIST = "ADD_WATCHLIST";
export const DELETE_WATCHLIST = "DELETE_WATCHLIST";
export const GET_WATCHLIST = "GET_WATCHLIST";
export const SEARCH_NOTFOUND = "SEARCH_NOTFOUND";
export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const COMMENT_LOADING = "COMMENT_LOADING";
export const CHANGE_PASS = "CHANGE_PASS";
export const PASSWORD_FAILED = "PASSWORD_FAILED";
export const FETCH_COMMENTSTATS = "FETCH_COMMENTSTATS";
export const FAILED_COMMENTS = "FAILED_COMMENTS";
